<template>
	<div class="login" v-loading="loading" element-loading-text="登陆中..." element-loading-background="rgba(0, 0, 0, .5)">
		<div class="loginBox">
			<div class="projectTile">
				<img src="../assets/images/title.png" alt="智慧林业一体化平台">
			</div>
			<!-- 登录 -->
			<div style="display: flex;align-items: center;display: -webkit-box">
				<div class="login-box-left">
					<div class="content">
						<span>欢迎使用</span>
						<img src="../assets/images/jt.png" class="icon">
					</div>
				</div>
				<div
					class="login-box"
					v-show="type == 'login'"
				>
					<span class="title">账号登录</span>
					<div class="role">
						<span :class="roleType=='1'?'active':''" @click="roleType='1'">主管部门</span>
						<span :class="roleType=='2'?'active':''" @click="roleType='2'" style="margin-left: 30px;">企业/个人</span>
					</div>
					<el-form :model="loginForm" :rules="rules" ref="loginForm">
						<el-form-item prop="phoneNumber">
							<el-input v-model="loginForm.phoneNumber" placeholder="请输入手机号" clearable>
								<i slot="prefix" class="el-input__icon el-icon-mobile-phone"></i>
							</el-input>
						</el-form-item>
						<el-form-item prop="Password" v-if="loginType == 'password'">
							<el-input v-model="loginForm.password" placeholder="请输入密码" clearable show-password>
								<i slot="prefix" class="el-input__icon el-icon-unlock"></i>
							</el-input>
						</el-form-item>
						<el-form-item prop="code" v-if="loginType == 'code'">
							<el-input autoComplete="off" v-model="loginForm.code" placeholder="验证码" clearable>
								<i slot="prefix" class="el-input__icon el-icon-unlock"></i>
								<template slot="append">
									<span v-show="countdown == 0" @click="sendCode(3)">获取验证码</span>
									<span v-show="countdown !== 0">重新获取({{ countdown }})</span>
								</template>
							</el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="success" @click="login" :loading="loadingLogin" style="width: 100%;background: #086631;border-color: #086631;">登 录</el-button>
							<!-- <div>
								<el-radio v-model="roleType" label="1">工作人员</el-radio>
								<el-radio v-model="roleType" label="2">普通用户</el-radio>
								
							</div> -->
						</el-form-item>
						<!-- <el-form-item>
						<el-button style="width:100%" type="primary"  @click="login">登 录</el-button>
				    </el-form-item> -->
						<el-form-item>
							<div class="operation">
								<span class="login-span">
									<span @click="changeType('forget')">忘记密码?</span>
									<el-divider direction="vertical"></el-divider>
									<span @click="changeType('loginByCode')" v-if="loginType == 'password'">验证码登录</span>
									<span @click="changeType('login')" v-else>密码登录</span>
									<el-divider direction="vertical" ></el-divider>
									<span @click="changeType('register')" >企业/个人帐号注册</span>
								</span>
							</div>
						</el-form-item>
					</el-form>
				</div>
				<!-- 修改密码 -->
				<div
					class="login-box"
					v-show="type == 'forget'"
				>
					<span class="title">修改密码</span>
					<el-form :model="passwordForm" :rules="rules" ref="passwordForm">
						<el-form-item prop="phoneNumber">
							<el-input v-model="passwordForm.phoneNumber" placeholder="请输入手机号" clearable></el-input>
						</el-form-item>
						<el-form-item prop="code">
							<el-input autoComplete="off" v-model="passwordForm.code" placeholder="请输入验证码" clearable>
								<template slot="append">
									<span v-show="countdown == 0" @click="sendCode(2)">获取验证码</span>
									<span v-show="countdown !== 0">重新获取({{ countdown }})</span>
								</template>
							</el-input>
						</el-form-item>
						<el-form-item prop="password">
							<el-input
								autoComplete="new-password"
								type="password"
								v-model="passwordForm.password"
								placeholder="请输入新密码"
								clearable
								show-password
							></el-input>
						</el-form-item>
						<el-form-item>
							<div class="footer">
								<el-button type="primary" @click="changePassword" :loading="loadingLogin" style="width: 100%;background: #086631;border-color: #086631;">重置密码</el-button>
							</div>
						</el-form-item>
						<el-form-item style="width: 75%;">
							<div class="operation">
								<span class="login-span">
									<span @click="changeType('login')">密码登录</span>
									<el-divider direction="vertical"></el-divider>
									<span @click="changeType('register')">注册帐号</span>
								</span>
							</div>
						</el-form-item>
					</el-form>
				</div>
				<!-- 账号注册 -->
				<div
					class="login-box"
					v-show="type == 'register'"
				>
					<span class="title">企业/个人账号注册</span>
					<el-form :model="registerForm" :rules="rules" ref="registerForm">
						<el-form-item prop="userName">
							<el-input v-model="registerForm.userName" placeholder="请输入用户名" clearable></el-input>
						</el-form-item>
						<el-form-item prop="phoneNumber">
							<el-input v-model="registerForm.phoneNumber" placeholder="请输入手机号" clearable></el-input>
						</el-form-item>
						<el-form-item prop="code">
							<el-input v-model="registerForm.code" placeholder="请输入验证码" clearable>
								<template slot="append">
									<span v-show="countdown == 0" @click="sendCode(1)">获取验证码</span>
									<span v-show="countdown !== 0">重新获取({{ countdown }})</span>
								</template>
							</el-input>
						</el-form-item>
						<el-form-item prop="password">
							<el-input
								v-model="registerForm.password"
								placeholder="请输入密码"
								clearable
								show-password
								autoComplete="new-password"
							></el-input>
						</el-form-item>
						<el-form-item>
							<div class="footer">
								<el-button type="primary" @click="register" :loading="loadingLogin" style="width: 100%;background: #086631;border-color: #086631;">确 定</el-button>
							</div>
						</el-form-item>
						<el-form-item style="width: 75%;">
							<div class="operation">
								<span class="login-span">
									<!-- <span @click="changeType('forget')">忘记密码?</span>
									<el-divider direction="vertical"></el-divider> -->
									<span @click="changeType('login')">密码登录</span>
								</span>
							</div>
						</el-form-item>
					</el-form>
				</div>
				
				<!-- <el-form :model="loginForm">
				  <el-form-item label="手机号">
				    <el-input v-model="loginForm.loginName"></el-input>
				  </el-form-item>
				  <el-form-item label="密码">
				    <el-input v-model="loginForm.password" type="password" show-password></el-input>
				  </el-form-item>
				  <el-form-item>
				    <el-button type="primary" @click="login" style="width: 100%"
				      >登 录</el-button
				    >
				  </el-form-item>
				  <el-form-item>
				    <el-button
				      type="primary"
				      @click="$router.push('/register')"
				      style="width: 100%"
				      >注 册</el-button
				    >
				  </el-form-item>
				</el-form> -->
			</div>
			
		</div>
	</div>
</template>

<script>
/**
 * @description: 登录页面
 */

import { userLogin, getUserInfo,getCodeByUser, userRegister, workUserLogin,LoginCodeByUser,ChangePasswordForceByUser,GetMyMapToken2 } from '../api/user';
import { GetDetails,getCodeByStaff,LoginCodeByStaff,GetMyMapToken,ChangePasswordForceByStaff } from '@/api/staff';
import { login } from '../assets/api/user-api';
import { setLocalStorage, getLocalStorage, removeLocalStorage } from '../utils/localStorage';
import { baseUrl2 } from '@/static/utils/lyconfig';
export default {
	name: 'login',
	data() {
		return {
			loadingLogin: false,
			loading: false,
			loginForm: {
				phoneNumber: '',
				password: '',
				code: ''
			},
			passwordForm: {
				code: '',
				phoneNumber: '',
				password: ''
			}, //修改密码表单
			registerForm: {
				userName: '',
				phoneNumber: '',
				code: '',
				password: ''
			}, //注册表单
			rules: {
				userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
				phoneNumber: [
					{ required: true, message: '请输电话号码', trigger: 'blur' }
					// {
					// 	pattern: /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[189]))\d{8}$/,
					// 	message: "请输入正确的手机号",
					// 	trigger: "blur",
					// }
				],
				code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
				passWord: [
				  // {
				  //   // 正则校验密码强度：长度大于6位，至少包含1个数字、1个大写字母、1个小写字母、1个特殊字符 比如：Abc@123
				  //   pattern: /^\S*(?=\S{6,})(?=\S*\d)(?=\S*[A-Z])(?=\S*[a-z])(?=\S*[!@#$%^&*? ])\S*$/,
				  //   message: "密码长度需要大于6位、且至少包含1个数字、1个大写字母、1个小写字母、1个特殊字符",
				  // },
				  {
				    required: true,
				    message: "请输入密码",
				    trigger: "blur",
				  },
				],
			},
			type: 'login',
			countdown: 0,
			loginType: 'password',
			// 角色类型
			roleType: '1',
			time:null,
			time2:null,
		};
	},
	mounted() {
		document.addEventListener('keydown', e=>{
			if(e.keyCode==13){
				if(this.type=='login'){
					this.login()
				}else if(this.type=='forget'){
					this.changePassword()
				}else {
					this.register()
				}
			}
		})
	},
	methods: {
		changeType(type) {
			this.countdown = 0;
			if (type == 'loginByCode') {
				this.loginType = 'code';
			} else {
				this.loginType = 'password';
				this.type = type;
			}
		},
		// 修改密码
		changePassword() {
			this.$refs['passwordForm'].validate(async valid => {
				if (valid) {
					const formJson = {
						newPassword: this.passwordForm.password,
						key: this.passwordForm.code,
						mobile: parseInt(this.passwordForm.phoneNumber)
					};
					let data = {};
					if(this.roleType=='1'){
						const res = await ChangePasswordForceByStaff(formJson);
						data = res.data;
					}else{
						const res = await ChangePasswordForceByUser(formJson);
						data = res.data;
					}
					if (data.state === 1) {
						this.$message.success('修改成功');
						setTimeout(() => {
							this.changeType('login');
						}, 1000);
					} else {
						this.$message.error(data.msg);
					}
				}
			});
		},
		// 注册账号
		register() {
			this.$refs['registerForm'].validate(async valid => {
				if (valid) {
					const formJson = {
						name: this.registerForm.userName,
						passWord: this.registerForm.password,
						key: this.registerForm.code,
						phone: parseInt(this.registerForm.phoneNumber)
					};
					const { data } = await userRegister(formJson);
					if (data.state === 1) {
						this.$message.success('注册成功');
						setTimeout(() => {
							this.changeType('login');
						}, 1000);
					} else {
						this.$message.error(data.msg);
					}
				}
			});
		},
		// 登录
		 login() {
			this.$refs.loginForm.validate(async valid=>{
				if(valid){
					this.loading = true
					// 因为后端需要接受json数据，所以将form转换为json格式
					// const formJson = this.loginForm;
					const formJson = { loginName: this.loginForm.phoneNumber, passWord: this.loginForm.password, type: 0 };
					// // 模拟地图派端登陆
					// const gispaiLoginInfo = {
					// 	LoginName: '18450097257',
					// 	Password: 'ye123456',
					// 	LoginType: '5'
					// };
					// const data_gispai = await login(gispaiLoginInfo);
					// if (data_gispai.data.Status === 1) {
					// 	setLocalStorage('user-token-gispai', data_gispai.data.Token);
					// }
					
					let data = {};
					if (this.roleType == '1') {
						// 工作人员
						if(this.loginType == 'code'){
							let params ={
								loginName: this.loginForm.phoneNumber, 
								code: this.loginForm.code, 
								type: 0 
							}
							const res = await LoginCodeByStaff(params);
							data = res.data;
						}else{
							const res = await workUserLogin(formJson);
							data = res.data;
						}
					} else {
						// 普通用户
						if(this.loginType == 'code'){
							let params ={
								loginName: this.loginForm.phoneNumber, 
								code: this.loginForm.code, 
								type: 0 
							}
							const res = await LoginCodeByUser(params);
							data = res.data;
						}else{
							const res = await userLogin(formJson);
							data = res.data;
						}
					}
					if (data.state === 1) {
						setLocalStorage('user-token', data.token);
						setLocalStorage('user-token-gispai', data.mapToken);
						let imageUrl = `${baseUrl2}/api/File/ShowBigImage?token=${data.token}&isWorker=${this.roleType}&id=`
						this.$store.commit('set_imageUrl', imageUrl)
						let imageUrl2 = `${baseUrl2}/api/File/ShowImage?token=${data.token}&isWorker=${this.roleType}&id=`
						this.$store.commit('set_imageUrl2', imageUrl2)
						let fileUrl = `${baseUrl2}/api/File/DownFilesStaff?token=${data.token}&isWorker=${this.roleType}&id=`
						this.$store.commit('set_fileUrl', fileUrl)
						let videoUrl = `${baseUrl2}/api/File/ReadVideo?token=${data.token}&isWorker=${this.roleType}&id=`
						this.$store.commit('set_videoUrl', videoUrl)
						if (this.roleType == '1') {
							// 工作人员
							GetDetails().then(res => {
								if (res.data.state == 1) {
									let userInfo = res.data.data.staffInfo;
									
									userInfo.userPower = res.data.data.staffPowers;
									setLocalStorage('user', userInfo);
									setLocalStorage('user_gispai', userInfo.re);
									setLocalStorage('user-token-gispai', userInfo.mapToken);
									setLocalStorage('user-userId', userInfo.mapUserId);
									this.$store.commit('set_user',userInfo)
									
									// this.$message.success('登录成功');
									setLocalStorage('isWorker', true);
									this.$router.push('/home');
									// this.$router.push('/dataScreen');
									this.$store.commit('set_isWorker',true)
									this.$store.commit('setIsExpiry',false)
									// this.getDtpToken()
									// this.$message({
									// 	type: 'success',
									// 	message: '登录成功',
									// 	duration:1500
									// });
								}
							});
						} else {
							// 普通用户
							getUserInfo().then(res => {
								if (res.data.state == 1) {
									let userInfo = res.data.data
									userInfo.userPower = JSON.parse(userInfo.userPower);
								// 	userInfo.Faclis = userInfo.faclis
								
								// 	userInfo.Felllis = userInfo.felllis
									setLocalStorage('user', userInfo);
									setLocalStorage('user-token-gispai', userInfo.mapToken);
									this.$store.commit('set_user',userInfo)
									
									setLocalStorage('isWorker', false);
									this.$store.commit('setIsExpiry',false)
									if(userInfo.isSJGS == true){
										setLocalStorage('user_gispai', userInfo.re);
										this.$router.push('/SJGS/myReserve');
										this.$store.commit('setActivateMenu', 41)
										this.$store.commit('setActivateMenuUrl', '/SJGS/myReserve')
									}else{
										this.$router.push('/infoManage/fellAreaManage');
										this.$store.commit('setActivateMenu', 1)
										this.$store.commit('setActivateMenuUrl', '/infoManage/fellAreaManage')
									}
									// this.$router.push('/userCenter');
									this.$store.commit('set_isWorker',false)
									// this.$message({
									// 	type: 'success',
									// 	message: '登录成功',
									// 	duration:1500
									// });
									// this.getDtpToken2()
								}
							});
						}
						// this.loading = false
					}else {
						// this.$message.error(data.msg);
						this.loading = false
						if(data.state == -2 ){
							this.passwordForm.phoneNumber = this.loginForm.phoneNumber
							this.type = 'forget'
						}
					}
				}else{
					return false
				}
			})
		},
		// 获取地图派token
		getDtpToken(){
			this.time = setInterval(()=>{
				let token = JSON.parse(localStorage.getItem('user-token-gispai'))
				GetMyMapToken(token).then(res=>{
					if(res.data.state>0){
						if(res.data.state==2){
							let user_gispai = JSON.parse(JSON.parse(localStorage.getItem("user_gispai")))
          					user_gispai.Token = res.data.data
          					localStorage.setItem('user_gispai',JSON.stringify(JSON.stringify(user_gispai)))
							localStorage.setItem('user-token-gispai', JSON.stringify(res.data.data));
						}
					}else{
						this.time = null
						this.$message.error(res.data.msg)
					}
				})
			},3600000)
		},
		getDtpToken2(){
			this.time2 = setInterval(()=>{
				let token = JSON.parse(localStorage.getItem('user-token-gispai'))
				GetMyMapToken2(token).then(res=>{
					if(res.data.state>0){
						if(res.data.state==2){
							localStorage.setItem('user-token-gispai', JSON.stringify(res.data.data));
							let user_gispai = JSON.parse(JSON.parse(localStorage.getItem("user_gispai")))
          					user_gispai.Token = res.data.data
          					localStorage.setItem('user_gispai',JSON.stringify(JSON.stringify(user_gispai)))
						}
					}else{
						this.time2 = null
						this.$message.error(res.data.msg)
					}
				})
			},3600000)
		},
		// 发送验证码
		sendCode(type) {
			var reg = /^1[23456789]\d{9}$/;
			if (type == 1) {
				if (this.registerForm.phoneNumber == '') {
					this.$message({
						type: 'error',
						message: '请先输入您的手机号'
					});
				} else if (!reg.test(this.registerForm.phoneNumber)) {
					this.$message({
						type: 'error',
						message: '您输入的手机号格式不正确'
					});
				} else {
					this.countdown = 59;
					var el = document.getElementsByClassName('el-input-group__append')[1];
					el.style.backgroundColor = '#f4f4f5';
					el.style.borderColor = '#e9e9eb';
					el.style.color = '#bcbec2';
					this.getCountdown(type);
					let param = {
						mobile: parseInt(this.registerForm.phoneNumber),
						messageType: type
					};
					getCodeByUser(param).then(res => {
						if (res.data.state == 1) {
							this.$message.success('发送成功');
							return;
						} else {
							this.$message.error(res.data.msg);
						}
					});
				}
			} else if(type==2) {
				if (this.passwordForm.phoneNumber == '') {
					this.$message({
						type: 'error',
						message: '请先输入您的手机号'
					});
				} else if (!reg.test(this.passwordForm.phoneNumber)) {
					this.$message({
						type: 'error',
						message: '您输入的手机号格式不正确'
					});
				} else {
					this.countdown = 59;
					var el = document.getElementsByClassName('el-input-group__append')[0];
					el.style.backgroundColor = '#f4f4f5';
					el.style.borderColor = '#e9e9eb';
					el.style.color = '#bcbec2';
					this.getCountdown(type);
					let param = {
						mobile: parseInt(this.passwordForm.phoneNumber),
						messageType: 2	
					};
					if(this.roleType=='1'){
						getCodeByStaff(param).then(res => {
							if (res.data.state == 1) {
								this.$message.success('发送成功');
							} else {
								this.$message.error(res.data.msg);
							}
						});
					}else{
						getCodeByUser(param).then(res => {
							if (res.data.state == 1) {
								this.$message.success('发送成功');
							} else {
								this.$message.error(res.data.msg);
							}
						});
					}
				}
			}else{
				if (this.loginForm.phoneNumber == '') {
					this.$message({
						type: 'error',
						message: '请先输入您的手机号'
					});
				} else if (!reg.test(this.loginForm.phoneNumber)) {
					this.$message({
						type: 'error',
						message: '您输入的手机号格式不正确'
					});
				} else {
					this.countdown = 59;
					var el = document.getElementsByClassName('el-input-group__append')[0];
					el.style.backgroundColor = '#f4f4f5';
					el.style.borderColor = '#e9e9eb';
					el.style.color = '#bcbec2';
					this.getCountdown(type);
					let param = {
						mobile: parseInt(this.loginForm.phoneNumber),
						messageType: 2
					};
					if(this.roleType=='1'){
						getCodeByStaff(param).then(res => {
							if (res.data.state == 1) {
								this.$message.success('发送成功');
							} else {
								this.$message.error(res.data.msg);
							}
						});
					}else{
						getCodeByUser(param).then(res => {
							if (res.data.state == 1) {
								this.$message.success('发送成功');
							} else {
								this.$message.error(res.data.msg);
							}
						});
					}
				}
			}
		},
		getCountdown(type) {
			var that = this;
			var num = type == 1 ? 1 : 0;
			var timer = setInterval(function() {
				if (that.countdown > 0) {
					that.countdown--;
				} else {
					var el = document.getElementsByClassName('el-input-group__append')[num];
					el.style.backgroundColor = '#086631';
					el.style.borderColor = '#086631';
					el.style.color = '#fff';
					clearInterval(timer);
				}
			}, 1000);
		}
	}
};
</script>
<style scoped lang="less">
.login {
	width: 100%;
	height: 100%;
	background: url('../assets/images/bg.jpg');
	background-size: cover;
	.loginBox {
		padding: 15px;
		background-color: transparent;
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		.operation {
			.login-span {
				float: right;
				font-size: 12px;
				span {
					cursor: pointer;
					&:hover {
						text-decoration: underline;
					}
				}
			}
		}
		.login-box-left {
			flex: 1;
			min-width: 450px;
			background: rgba(255, 255, 255, .5);	
			border-radius: 5px 0  0 5px;
			color: #086631;
			position: relative;
			.content {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%,-50%);
				font-size: 28px;
				font-weight: bold;
				display: flex;
				align-items: center;
				.icon {
					width: 26px;
					height: 25px;
					margin-left: 15px;
				}
			}
		}
		.login-box {
			// margin-left: 100px;
			flex: 1;
			min-width: 450px;
			background: #fff;
			border: 1px solid #e3e3e3;
			border-radius: 0 5px 5px 0px;
			box-shadow: 0 0 6px 0 rgba(163, 163, 163, 0.5);
			text-align: center;
			padding: 50px 0px 20px 0px;
			.title {
				font-size: 20px;
				color: #333;
			}
			.role {
				margin-top: 20px;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 20px;
				color: #a1a1a1;
				cursor: pointer;
				.active{
					color: #086631;
					font-weight: bold;
					position: relative;
				}
				.active::after {
					content: '';
					width: 60px;
					height: 2px;
					// border-radius: 50%;
					background-color: #086631;
					position: absolute;
					bottom: -15px;
					left: 50%;
					transform: translateX(-50%);
				}
			}
			.el-form {
				margin-top: 23px;
				.el-form-item {
					margin: auto;
					margin-bottom: 20px;
					width: 60%;
				}
				/deep/ .el-input__inner {
					height: 40px;
				}
			}
			.wechat-qrcode-cantainer {
				overflow: hidden;
				height: 220px;
			}
		}
		/deep/ .el-input-group__append {
			background-color: #086631;
			border-color: #086631;
			color: #fff;
			span {
				cursor: pointer;
			}
		}
	}
	.projectTile {
		position: absolute;
		top: -50px;
		left: 50%;
		transform: translateX(-50%);
		img {
			height: 45px;
		}
		// height: 45px;
		// width: 435px;
	}
	/deep/.el-loading-spinner .el-loading-text{
		color: #fff!important;
  }
}
</style>
